import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { deleteReview, fetchReviewList } from "src/services/review.service";

interface FetchReviewListPayload {
  page: number;
  limit: number;
  // search?: string;
}

export const doFetchReviewList = createAsyncThunk(
  "review/fetchReviewList",
  async (payload: FetchReviewListPayload) => {
    try {
      const response: any = await fetchReviewList({
        page: payload.page,
        limit: payload.limit,
        // search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch review list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doDeleteReview = createAsyncThunk(
  "review/deleteReview",
  async (ruid: string) => {
    try {
      const response: any = await deleteReview(ruid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete review";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
